export enum MarkdownAutosaveInterval {
  Disabled = 0,
  TwoSeconds = 2000,
  FiveSeconds = 5000,
  TenSeconds = 10000,
  ThirtySeconds = 30000
}
